'use client';

import { useEffect } from 'react';
import { useCartCheckoutStore } from 'stores/cart';

/** The consent must be given per visit of the step, so a tick from an earlier visit must not survive. Renders nothing. */
export function ResetCheckoutState() {
  const reset = useCartCheckoutStore(store => store.reset);

  useEffect(() => {
    reset();
  }, [reset]);

  return null;
}
